/**
 * If client has mobile apps and browser is mobile, redirects to page asking user to download the app.
 * @returns {Promise}
 */
export default function ({ store, redirect, route }) {
  if (store.state.config.apps) {
    const capps = store.state.config.apps;

    return import('clientjs').then(({ ClientJS }) => {
      if (ClientJS) {
        // If is mobile and there is an store url set, proceed with checks
        const client = new ClientJS();
        const ios = capps?.ios?.storeUrl && client.isMobileIOS();
        const android = capps?.android?.storeUrl && client.isMobileAndroid();

        if (ios || android) {
          /* Redirect only if it's a signup page and signup redirection is enabled
             or if login redirection is enabled  */
          const opts = ios ? capps.ios : capps.android;

          if (
            (/^\/sign-up/.test(route.path) && opts?.redirectCases?.signup) ||
            opts?.redirectCases?.login
          ) {
            return redirect({ path: '/go-to-app' });
          }
        }
      }
      return true;
    });
  }

  return Promise.resolve(true);
}
